import 'core-js/stable/object/assign';
import 'core-js/es/promise';
import 'core-js/es/array/flat-map';

// Import styles
import '@fortawesome/fontawesome-pro/scss/fontawesome.scss';
import '@fortawesome/fontawesome-pro/scss/solid.scss';
import '@fortawesome/fontawesome-pro/scss/regular.scss';
import '@fortawesome/fontawesome-pro/scss/light.scss';
import '@fortawesome/fontawesome-pro/scss/duotone.scss';
import './scss/main.scss';

// jQuery
import $ from 'jquery'

window.$ = window.jQuery = $;

import * as Sentry from '@sentry/vue';

Sentry.init({
    Vue,
    dsn: process.env.SENTRY_FRONTEND_DSN,
    integrations: [
        new Sentry.BrowserTracing(),
        new Sentry.Replay(),
    ],
    // Capture Replay for 5% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 0.1,
    trackComponents: true,
    maskAllText: false,
    maskAllInputs: false,
    timeout: 500,
});

// Vue
import Vue from 'vue';
import RefundView from './RefundView.vue';
import DisruptionsApp from './DisruptionsApp.vue';
import AdvanceInfoModal from './AdvanceInfoModal.vue';
import DelayRepayWhichOperator from './DelayRepayWhichOperator.vue';

// Vue plugins
import VuePluralize from 'vue-pluralize';
import VueInsProgressBar from 'vue-ins-progress-bar'
import VueFilterDateFormat from 'vue-filter-date-format';

// Luxon
import { Settings } from "luxon";

// Configure the time zone
Settings.defaultZoneName = "Europe/London";

// Polyfills for sane JS APIs
import 'url-search-params-polyfill';

import './journey-choice.js';
import './error-reporting';
import {ErrorReporting} from "./error-reporting";
import Axios from "axios";
import initialisePrintedManualRefunds from "./printed-manual-refunds";

const er = new ErrorReporting();
er.init();

const wireUpAutoTrim = () => {
    const nodes = document.querySelectorAll('input[data-autotrim]');
    for (const node of nodes) {
        if (node.dataset.autotrimRegistered === 'true') {
            continue;
        }

        node.addEventListener("paste", (event) => {
            let thisNode = event.currentTarget;
            event.preventDefault();
            const text = event.clipboardData.getData("text/plain").trim();

            const { selectionStart, selectionEnd } = thisNode;
            thisNode.setRangeText(text, selectionStart, selectionEnd, "end");
        });
        node.dataset.autotrimRegistered = 'true';
    }
}

$(($) => {
    let advanceInfoModel = null;
    $('.launch-advance-refund-modal').click((e) => {
        e.preventDefault();
        if (advanceInfoModel === null) {
            advanceInfoModel = new (Vue.extend(AdvanceInfoModal))({
                el: '#advance-modal-mount-point',
            });
        } else {
            advanceInfoModel.open = true;
        }
    });

    let delayRepayWhichOperatorModal = null;
    $('.launch-delay-repay-which-operator-modal').click((e) => {
        e.preventDefault();
        if (delayRepayWhichOperatorModal === null) {
            delayRepayWhichOperatorModal = new (Vue.extend(DelayRepayWhichOperator))({
                el: '#delay-repay-which-operator-modal-mount-point',
            });
        } else {
            delayRepayWhichOperatorModal.open = true;
        }
    });

    const getAppealsEmails = function () {
        return window.atob($("body").data("appeals-email").split('').reverse().join(''));
    };
    window.getAppealsEmail = getAppealsEmails;

    $(".appeals-email-link").attr("href", "mailto:"+getAppealsEmails());

    $(':required').one('blur keydown', function () {
        $(this).addClass('touched');
    });

    Vue.use(VuePluralize);
    const options = {
        position: 'fixed',
        show: true,
        height: '6px'
    };

    Vue.use(VueInsProgressBar, options);
    Vue.use(VueFilterDateFormat);
    console.log("Registered dateFormat");

    let $disruptionsApp = $("#disruptions-mount-point");
    if ($disruptionsApp.length === 1) {
        new (Vue.extend(DisruptionsApp))({
            el: '#disruptions-mount-point',
            propsData: {
                'refundStatus': JSON.parse($("#refundStatus").html()),
                'journeyId': $("#refundStatus").data("journeyId"),
                'email': $("#refundStatus").data("email"),
                'delayRepayAdviceUrl': $("#refundStatus").data("delay-repay-advice")
            }
        });
    }

    let $app = $("#app-mount-point");
    $app.html("<h2>Ticket Refunds</h2><p><i class='fad fa-spinner-third fa-spin' aria-hidden='true'></i> Initialising application&hellip;</p>");
    let $journeyDetails = $("#journeyDetails");
    if ($journeyDetails.length === 1) {

        new (Vue.extend(RefundView))({
            el: '#app-mount-point',
            propsData: {
                'details': JSON.parse($journeyDetails.html()),
                'refundStatusUrl': $journeyDetails.data('refund-info-url'),
                'dryRunUrl': $journeyDetails.data('dry-run-url'),
                'appealsEmail': getAppealsEmails()
            }
        });
    } else {
        $app.html("<h2>Ticket Refunds</h2><p>Missing JSON data from DOM. Please report to Trainsplit.</p>");
    }

    $(".refund-reason-list").on("change", function(ev) {
        if ($(this).val() === 'Disruption') {
            $(".wheelchair-funnel").addClass("hide");
            $(".disruption-delay-repay-funnel").removeClass("hide");
            $("[name='disruption-reason']").attr("required", "");
        } else if ($(this).val() === 'Wheelchair') {
            $(".disruption-delay-repay-funnel").addClass("hide");
            $(".wheelchair-funnel").removeClass("hide");
            $("[name='disruption-reason']").removeAttr("required");
        } else {
            $(".wheelchair-funnel").addClass("hide");
            $(".disruption-delay-repay-funnel").addClass("hide");
            $("[name='disruption-reason']").removeAttr("required");
        }
    });

    $("[name='disruption-reason']").on("change", function(ev) {
        if ($(this).val() === "abandoned-journey") {
            $("[name='disruption-reason']").each(function() {
                $(this).get(0).setCustomValidity("");
            });
            $(".delay-repay-warning").addClass("hide");
            $(".bottom-text").removeClass("faded-out");
        } else {
            $(".delay-repay-warning").removeClass("hide");
            $(".bottom-text").addClass("faded-out");
            $(this).get(0).setCustomValidity("Delay repay requests must be sent to the train operating company");
        }
    });


    initialisePrintedManualRefunds();
    wireUpAutoTrim();

    const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                wireUpAutoTrim();
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
